/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Practice_Card_Audience_CohortInputs */



/**
* | output |
* | --- |
* | "Group · {title}" |
*
* @param {Practice_Card_Audience_CohortInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_card_audience_cohort = /** @type {((inputs: Practice_Card_Audience_CohortInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Card_Audience_CohortInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Groep · ${i?.title}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Groupe · ${i?.title}`)
	return /** @type {LocalizedString} */ (`Group · ${i?.title}`)
});